export default __webpack_public_path__ + "35cb771eee8ad116acd896fc21779c19.geojson";